import FlagIcon from "../../../../assets/svg/flag.svg?react";

export function Flag() {
  return <FlagIcon />;
}
